





















































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { InputCode } from '@/components/molecules/InputCode'

export interface InputEditLendItem {
  interlibraryLoanCode: {
    input: string
    errorMessage: string
  }
  borrowingDate: {
    input: string
    errorMessage: string
  }
  borrowingDueDate: {
    input: string
    errorMessage: string
  }
}

export const defaultInputEditLendItem = (): InputEditLendItem => ({
  interlibraryLoanCode: {
    input: '',
    errorMessage: ''
  },
  borrowingDate: {
    input: '',
    errorMessage: ''
  },
  borrowingDueDate: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputDatePicker,
    InputCode
  }
})
export default class CollectionEditLendAndOtherLendInfo extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputEditLendItem

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
